import React, { Component, useEffect } from 'react';
import { Hidden, Drawer, Badge, FormHelperText } from '@material-ui/core';
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Grid from "@material-ui/core/Grid/Grid";
import Button from "@material-ui/core/Button/Button";
import Divider from "@material-ui/core/Divider/Divider";
import Modal from "@material-ui/core/Modal/Modal";
import { Avatar, Icon } from '@material-ui/core';
import { InfoOutlined, CloseOutlined, AccountCircle } from '@material-ui/icons';
import { NotificationManager } from "react-notifications";
import { primaryColor, webFont } from '../../config/theme';
import { BOOKING_STATUS } from "../../config/constants";
import { client } from '../../config/apollo';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import format from 'date-fns/format';
import {
  DatePicker,
  MuiPickersUtilsProvider
} from "@material-ui/pickers";
import { GET_CALENDAR_SLOTS } from '../../graphql/queries/schedule';
import {UPDATE_BOOKING, MAKE_PROPOSAL, UPDATE_PROPOSAL_READ} from "../../graphql/mutations/booking";
import {BOOKING_TRANSACTION} from '../../graphql/queries/bookings';
import {USER_PROFILE} from '../../graphql/queries/user';
import {connect} from "react-redux";
import { parseAmountDecimal } from "../../utils/common-methods";
import { InputAdornment, MenuItem, Select, Typography } from '@material-ui/core';
import Input from '@material-ui/core/Input';
import TextField from '@material-ui/core/TextField/TextField';
import { SelectedChefAvailability } from '../../redux/bookings';


class FrDateFnsUtils extends DateFnsUtils {
  startOfMonth(date) {
    return moment(date).startOf('month').toDate();
  }

  getDatePickerHeaderText(date) {
    return format(date, 'd MMMM', {locale: this.locale})
  }
}

class BookingCard extends Component {
  constructor (props) {
    super(props);

    this.state = {
      showTransactionModal: false,
      showProposalModal: false,
      showProposalAcceptedModal: false,
      showDatePicker: false,
      amount: 100,
      planName: '',
      transactionFee: 0,
      planPrice: 0,
      bookingDate: new Date(),
      couponCode: null,
      transactionFeeMsg: 'The details of the transaction fee will show here.',
      selectedMeridiem: 'AM',
      selectedTimeHour: 11,
      selectedTimeMinutes: "00",
      selectedMeridiemEnd: 'AM',
      selectedTimeHourEnd: 11,
      selectedTimeMinutesEnd: "00",
      selectedChefId: null,
      selectedDate: null,
      selectedMonth: null,
      proposalMessage: '',
      isCounterProposal: false,
      showProposalHistory: false,
      userProfileDetails: null,
      monthlySlots: []
    };
  }

  fetchTransactionFee = (bookingId, booking) => {
    client.query({
      query: BOOKING_TRANSACTION,
      variables: {
        id: bookingId
      },
      fetchPolicy: 'network-only'
    }).then(response => {
      const { fetchTransactionFeeForBooking } = response.data;
      if (fetchTransactionFeeForBooking) {
        const { couponCode, planName, planPrice, transactionFee } = fetchTransactionFeeForBooking;
        const feeVal = booking.transactionFeeCharges ? booking.transactionFeeCharges : transactionFee;
        const msg = `Transaction fee charged is ${feeVal * 100}% based on <strong>${planName}</strong>${couponCode ? `, with coupon <strong>${couponCode}</strong>` : ''}`;
        this.setState({ showTransactionModal: true, transactionFeeMsg: msg });
      }
    })
      .catch(err => {
        this.setState({ showTransactionModal: true, transacitonFeeMsg: 'Oops! There was an error fetching details. Please try again.' })
      });
  };

  fetchMonthlySlots = () => {
    if (!this.state.selectedChefId && !this.state.selectedMonth) return;

      client.query({
          query: GET_CALENDAR_SLOTS,
          variables: {
            chefId: this.state.selectedChefId,
            start: moment(this.state.selectedMonth, 'MM')
              .startOf("month")
              .format("YYYY-MM-DD"),
            end: moment(this.state.selectedMonth, 'MM')
              .endOf("month")
              .format("YYYY-MM-DD")
          },
          fetchPolicy: "network-only"
        })
        .then(response => {
         this. setState({ monthlySlots: response.data })
        })
        .catch(err => console.error('ERROR FETCHING SLOTS FOR THE GIVEN MONTH', this.state.selectedMonth, err));
      this.props.dispatch(SelectedChefAvailability(this.state.selectedChefId, this.state.selectedDate));
  };

  openDatePicker = e => {
    this.setState({showDatePicker: !this.state.showDatePicker})
  };

  componentDidMount () {
    const { booking } = this.props;
    if (booking) {
      this.setState({
        amount: booking.amount || 200,
        selectedMeridiem: moment(booking.timeSlot.start, "hh:mm a").format("A") || 'AM',
        selectedTimeHour: parseInt(moment(booking.timeSlot.start, "hh:mm a").format("h")) || 11,
        selectedTimeMinutes: moment(booking.timeSlot.start, "hh:mm a").format("mm") || '00',
        selectedMeridiemEnd: moment(booking.timeSlot.end, "hh:mm a").format("A") || 'AM',
        selectedTimeHourEnd: parseInt(moment(booking.timeSlot.end, "hh:mm a").format("h")) || 11,
        selectedTimeMinutesEnd: moment(booking.timeSlot.end, "hh:mm a").format("mm") || '00',
        selectedDate: moment(new Date(booking.date)).toDate() || null,
        selectedMonth: moment(new Date(booking.date)).format("MM") || null,
      });
    }
  }

  handleSendProposal = () => {
     const payload = {};
    const { booking, chefAvailability, isChef } = this.props;

     const {
       bookingDate, amount, selectedMeridiem,
       selectedTimeHour, selectedTimeMinutes,
       selectedTimeHourEnd, selectedTimeMinutesEnd,
       selectedDate, selectedMonth, proposalMessage,
       selectedMeridiemEnd
     } = this.state;

     if (!bookingDate || !amount || !selectedMeridiem || !selectedTimeHour || !selectedTimeMinutes ||
       !selectedDate || !selectedMonth || !selectedMeridiemEnd || !selectedTimeHourEnd || !selectedTimeMinutesEnd) {
       NotificationManager.error('All fields are mandatory.', 'Proposal');
       return;
     }

     if (parseInt(amount) < 1) {
       NotificationManager.error('Amount cannot be less than 1.', 'Proposal');
       return;
     }

     const convertedDate = moment(selectedDate).format('DD MMM');

     const convertedDateTime = moment(convertedDate + " " +
       `${selectedTimeHour}:${selectedTimeMinutes} ${selectedMeridiem}`, 'DD MMM hh:mm A');

     const convertedDateTimeEnd = moment(convertedDate + " " +
       `${selectedTimeHourEnd}:${selectedTimeMinutesEnd} ${selectedMeridiemEnd}`, 'DD MMM hh:mm A');

    let format = 'HH:mm';
    let chefAvail = false;

    if (typeof chefAvailability === "object" && chefAvailability && !!chefAvailability.length && chefAvailability.length > 0) {
      let startTime = moment(convertedDateTime.format('HH:mm'), format);
      let endTime = moment(convertedDateTimeEnd.format('hh:mm A'), 'hh:mm A');

      chefAvailability.forEach(availableSlot => {
        let beforeTime = moment(availableSlot.start, format),
          afterTime = moment(availableSlot.end, format).add(1, 'minute');

        if ((startTime.isBetween(beforeTime, afterTime) || startTime.isSameOrAfter(beforeTime)) && (endTime.isSameOrBefore(afterTime) || endTime.isBetween(beforeTime, afterTime)) && startTime.isBefore(endTime)) {
          chefAvail = true;
        }
      });
    }

    if (!chefAvail) {
      if (isChef) NotificationManager.error('This slot is not available for booking.', 'Proposal');
      else NotificationManager.error('Chef is not available for the selected slot.', 'Proposal');
      return;
    }

     if (!convertedDateTime.isValid()) {
       NotificationManager.error('Please select a valid date time.', 'Proposal');
       return;
     }

     if (moment().isSameOrAfter(convertedDateTime)) {
       NotificationManager.error('Date cannot be in past', 'Proposal');
       return;
     }

     if (convertedDateTimeEnd.isSameOrBefore(convertedDateTime)) {
       NotificationManager.error('End time cannot be before the start time', 'Proposal');
       return;
     }

     payload.id = booking.id;
     payload.proposedDate = convertedDateTime.format('DD MMM YYYY');
     payload.proposedTime = convertedDateTime.format('HH:mm');
     payload.proposedTimeEnd = convertedDateTimeEnd.format('HH:mm');
     payload.proposedAmount = amount;
     payload.isCounterProposal = this.state.isCounterProposal;

     if (proposalMessage) {
       payload.proposalComments = proposalMessage;
     }

     client.mutate({
       mutation: MAKE_PROPOSAL,
       variables: payload
       })
       .then(response => {
         NotificationManager.info('Proposal sent to diner successfully.', 'Proposal', 4000);
         this.setState({ showProposalModal: false });
         if (this.props.fetchAgain) { this.props.fetchAgain() }
       })
       .catch(err => {
         console.error('ERR MAKING PROPOSAL: ', err);
         NotificationManager.error('Error making proposal. Please try again.', 'Proposal');
       });
  };

  getUserProfile = userId => {
    client.query({
        query: USER_PROFILE,
        variables: { userId },
        fetchPolicy: 'network-only'
      })
      .then(response => {
        if (response.data) {
          if (response.data.userProfile) {
            this.setState({ userProfileDetails: response.data.userProfile });
          }
        }
      })
      .catch(err => {
        console.error('ERR Fetching user profile : ', err);
        this.setState({ userProfileDetails: null });
      });
  };

  handleMonthChange = date => {
    const updatedMonth = moment(date).format('MM');
    this.setState({ selectedMonth: updatedMonth }, () => {
      this.fetchMonthlySlots();
    });
  };

  isInSchedule = date => {
    const {
      monthlySlots: {getCalendarSlots}
    } = this.state;


    let isAvailable = false;

    if (getCalendarSlots)
      isAvailable = getCalendarSlots.find(day => {
        return day.date === moment(date).format("YYYY-MM-DD");
      });

    return !!isAvailable;
  };

  renderWrappedWeekDay = (date, selectedDate, dayInCurrentMonth, dayComponent) => {
    let inDate = moment(date);
    const inCompDate = inDate.format("YYYY") + "-" + inDate.format("MM") + "-" + inDate.format("DD");
    inDate = moment(inCompDate);
    let today = moment(new Date());
    const compToday = today.format("YYYY") + "-" + today.format("MM") + "-" + today.format("DD");
    today = moment(compToday);

    if (inDate.isBefore(today)) {
      return <Badge>{dayComponent}</Badge>;
    }
    else {
      return <Badge badgeContent={<span
        style={{
          fontSize: 30,
          fontWeight: 500,
          color: this.isInSchedule(date) ? "green" : "white"
        }}
      >
                .
                </span>}>{dayComponent}</Badge>;
    }
  };

  handleDateChange = d => {
    this.setState({
      selectedDate: new Date(d)
    }, () => {
      this.props.dispatch(SelectedChefAvailability(this.state.selectedChefId, this.state.selectedDate));
    });
  };

  render() {
    const { booking, isChef, chefAvailability } = this.props;
    const minDate = moment().format("YYYY-MM-DD");

    let currentTime=moment(new Date());
    let bookingCompleteTime=moment(new Date(booking.date));
    let showComplete=false;
    bookingCompleteTime.set('hour', booking.timeSlot.end.split(":")[0].split(' ')[0]);
    bookingCompleteTime.set('minute', booking.timeSlot.end.split(":")[0].split(' ')[1]);
    if(currentTime > bookingCompleteTime && booking.status=== 'ACCEPTED'){
      showComplete=true;
    }

    let dishes = "";
    booking.dishes &&
    booking.dishes.length &&
      booking.dishes.map((dish, idx) => {
        dishes += dish.dishName;
        if (idx < booking.dishes.length - 1) {
          dishes += ", ";
        }
      });

    const availability = Array.isArray(chefAvailability) ? chefAvailability.length > 0 ? chefAvailability.map(chefAv => {
      return (`${moment(
        chefAv.start,
        "hh:mm a"
      ).format("LT")}- ${moment(chefAv.end, "hh:mm a").format(
        "LT"
      )}`);
    }) : [] : [];

    return (
      <Card className="booking-card">
        <CardContent>
          <Grid container style={{ position: 'relative' }}>
            <Grid item md={12} xs={12} style={style.container}>
              <Grid container>

                <Grid item md={7} sm={12}>
                  <Grid container alignItems={"center"}>
                    <Grid item md={12} xs={12}>
                      <p style={style.userName}>{isChef ? booking.userName : booking.chefName}</p>
                    </Grid>

                    <Grid item sm={4} md={4} xs={4}>
                      <p style={style.labelBold}>Date</p>
                    </Grid>
                    <Grid item sm={8} md={8} xs={8}>
                      <p style={{ ...style.value, fontWeight: 500}}>
                        {moment(new Date(booking.date)).format("DD MMM")}
                      </p>
                    </Grid>
                    <Grid item sm={4} md={4} xs={4}>
                      <p style={style.labelBold}>Time</p>
                    </Grid>
                    <Grid item sm={8} md={8} xs={8}>
                      <p style={{ ...style.value, fontWeight: 500}}>{`${moment(
                        booking.timeSlot.start,
                        "hh:mm a"
                      ).format("LT")} ${' - '}${moment(
                        booking.timeSlot.end,
                        "hh:mm a"
                      ).format("LT")}`}</p>
                    </Grid>
                    {booking.displayId && <><Grid item sm={4} md={4} xs={4}>
                      <p style={style.labelBold}>Booking Id</p>
                    </Grid>
                      <Grid item sm={8} md={8} xs={8}>
                      <p style={style.value}>
                    {booking.displayId}
                      </p>
                      </Grid></>}
                    <Grid item sm={4} md={4} xs={4}>
                      <p style={style.labelBold}>Type</p>
                    </Grid>
                      <Grid item sm={8} md={8} xs={8}>
                        <p style={style.value}>
                          {booking.isCustom ? 'Custom Booking' : 'A la Carte'}
                        </p>
                      </Grid>
                    {booking.isRecurring && <><Grid item sm={4} md={4} xs={4}>
                      <p style={style.labelBold}>Recurring</p>
                    </Grid>
                      <Grid item sm={8} md={8} xs={8}>
                        <p style={style.value}>
                          Yes
                        </p>
                      </Grid></>}
                  </Grid>
                </Grid>

                <Hidden smDown>
                  <Grid item sm={12} md={5} style={{ textAlign: "right" }}>
                    {booking.status === BOOKING_STATUS.INCOMPLETE && (
                      <Button
                        data-test-id={"continuecard"}

                        variant={"contained"}
                        size={"small"}
                        style={style.confirmedButton}
                        onClick={this.props.onContinue}
                      >
                        Continue
                      </Button>
                    )}
                    {booking.status === BOOKING_STATUS.ACCEPTED && !showComplete && (
                      <Button
                        data-test-id={"confirmedcard"}

                        variant={"contained"}
                        size={"small"}
                        style={style.confirmedButton}
                        onClick={this.props.onViewDetails}
                      >
                        Confirmed
                      </Button>
                    )}
                    {booking.status === BOOKING_STATUS.ACCEPTED && showComplete && (
                      <Button
                        data-test-id={"completecard"}

                        variant={"contained"}
                        size={"small"}
                        style={style.confirmedButton}
                        onClick={this.props.onComplete}
                      >
                        Confirmed
                      </Button>
                    )}

                    {booking.status === BOOKING_STATUS.ACCEPTED && (
                      <p style={style.confirmMessage}>
                        This engagement is confirmed.
                      </p>
                    )}

                    {booking.status === BOOKING_STATUS.PENDING && (
                      <Button
                        data-test-id={"pendingcard"}

                        variant={"contained"}
                        size={"small"}
                        style={style.pendingButton}
                      >
                        Pending
                      </Button>
                    )}
                    {booking.status === BOOKING_STATUS.PENDING && !isChef && (
                      <p style={style.confirmMessage}>
                        Awaiting chef's response.
                      </p>
                    )}
                    {booking.status === BOOKING_STATUS.PENDING && isChef && (
                      <p style={style.confirmMessage}>
                        Please review your engagement.
                      </p>
                    )}
                    {(booking.status === BOOKING_STATUS.COMPLETED || booking.status === BOOKING_STATUS.COMPLETED_BY_USER || booking.status === BOOKING_STATUS.COMPLETED_BY_CHEF) && (
                      <Button
                        data-test-id={"completedcard"}
                        variant={"outlined"}
                        size={"small"}
                        style={style.confirmedButton}
                      >
                        Completed
                      </Button>
                    )}
                    {(booking.status === BOOKING_STATUS.CANCELED || booking.status === BOOKING_STATUS.REJECTED || booking.status === BOOKING_STATUS.EXPIRED || booking.status === BOOKING_STATUS.CANCELED_BY_DINER
                      || booking.status === BOOKING_STATUS.CANCELED_BY_CHEF || booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_DINER || booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_CHEF) && (
                      <Button
                        data-test-id={"canceledcard"}

                        variant={"contained"}
                        size={"small"}
                        style={style.cancelButton}
                        onClick={this.props.onCanceled}
                      >
                        {booking.status === BOOKING_STATUS.CANCELED || booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_DINER || booking.status === BOOKING_STATUS.CANCELED_BY_DINER
                        || booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_CHEF ? 'Canceled' : booking.status === BOOKING_STATUS.EXPIRED ? 'Expired' : 'Declined'}
                      </Button>
                    )}
                    {booking.status === BOOKING_STATUS.CANCELED && (
                      <p style={style.confirmMessage}>
                        This engagement has been {booking.status === BOOKING_STATUS.REJECTED ? 'declined by chef.' : booking.status === BOOKING_STATUS.CANCELED_BY_CHEF ? 'canceled by chef.' : 'canceled.'}
                      </p>
                    )}
                    {(booking.status === BOOKING_STATUS.COMPLETED_BY_USER || booking.status === BOOKING_STATUS.COMPLETED_BY_CHEF || booking.status === BOOKING_STATUS.COMPLETED) && (
                      <p style={style.confirmMessage}>
                        This engagement has been completed.
                      </p>
                    )}
                  </Grid>
                </Hidden>


                <Grid item md={12} style={{ marginBottom: 15 }}>
                  <Divider />
                </Grid>

                <Grid item sm={12} md={8}>
                  {booking.isCustom && booking.status !== BOOKING_STATUS.REJECTED && <Grid container>
                    <Grid item sm={7} xs={12}>
                      <p style={style.dishesLabel}>
                        {booking.isCustom ? booking.proposalMade && booking.status === BOOKING_STATUS.PENDING ? 'Proposed Amount' :
                          booking.status === BOOKING_STATUS.ACCEPTED || booking.status === BOOKING_STATUS.COMPLETED ||
                          booking.status === BOOKING_STATUS.COMPLETED_BY_CHEF || booking.status === BOOKING_STATUS.COMPLETED_BY_USER ? 'Billed Amount' :
                            booking.proposalMade ? 'Proposed Amount' : 'Price Range' : 'Billed Amount'}
                      </p>
                    </Grid>
                    <Grid item sm={5} xs={12}>
                      <p style={style.value}>
                        ${booking.isCustom && booking.status === BOOKING_STATUS.PENDING ? booking.proposalMade ? parseAmountDecimal(booking.proposedAmount) :
                        `${booking.startPrice || 0} - $${booking.endPrice || 0}` :
                        booking.isCustom ? booking.proposalMade ? parseAmountDecimal(booking.proposedAmount) :
                          `${booking.startPrice || 0} - $${booking.endPrice || 0}` : parseAmountDecimal(booking.amount)}
                      </p>
                    </Grid>
                  </Grid>}
                  {booking.isCustom && (booking.status === BOOKING_STATUS.REJECTED) && <Grid container>
                    <Grid item sm={7} xs={12}>
                      <p style={style.dishesLabel}>
                        {booking.proposalMade ? 'Proposed Amount' : 'Price Range'}
                      </p>
                    </Grid>
                    <Grid item sm={5} xs={12}>
                      <p style={style.value}>
                        ${booking.proposalMade ? parseAmountDecimal(booking.proposedAmount) : `${booking.startPrice || 0} - $${booking.endPrice || 0}`}
                      </p>
                    </Grid>
                  </Grid>}
                  {!booking.isCustom && <Grid container>
                    <Grid item sm={booking.isCustom ? 7 : 8} xs={12}>
                      <p style={style.dishesLabel}>
                        {booking.isCustom ? booking.proposalMade && booking.status === BOOKING_STATUS.PENDING ? 'Proposed Amount' :
                          booking.status === BOOKING_STATUS.ACCEPTED || booking.status === BOOKING_STATUS.COMPLETED ||
                          booking.status === BOOKING_STATUS.COMPLETED_BY_CHEF || booking.status === BOOKING_STATUS.COMPLETED_BY_USER ? 'Billed Amount' :
                            'Price Range' : 'Billed Amount'}
                      </p>
                    </Grid>
                    <Grid item sm={booking.isCustom ? 5 : 4} xs={12}>
                      <p style={style.value}>
                        ${booking.isCustom && booking.status === BOOKING_STATUS.PENDING ? booking.proposalMade ? parseAmountDecimal(booking.proposedAmount) :
                          `${booking.startPrice || 0} - $${booking.endPrice || 0}` :
                        parseAmountDecimal(booking.amount)}
                      </p>
                    </Grid>
                  </Grid>}
                  {booking.isCustom && booking.status === BOOKING_STATUS.PENDING && booking.proposalMade && <Grid container>
                    <Grid item sm={7} xs={12}>
                      <p style={style.dishesLabel}>
                        Proposed Date
                      </p>
                    </Grid>
                    <Grid item sm={5} xs={12}>
                      <p style={style.value}>
                        {moment(booking.proposedDate).format('DD MMM')}
                      </p>
                    </Grid>
                  </Grid>}
                  {booking.isCustom && booking.status === BOOKING_STATUS.PENDING && booking.proposalMade && <Grid container>
                    <Grid item sm={7} xs={12}>
                      <p style={style.dishesLabel}>
                        Proposed Time
                      </p>
                    </Grid>
                    <Grid item sm={5} xs={12}>
                      <p style={style.value}>
                        {moment(booking.proposedTime, 'HH:mm').format('hh:mm A')} -
                        {moment(booking.proposedTimeEnd, 'HH:mm').format('hh:mm A')}
                      </p>
                    </Grid>
                  </Grid>}
                  <Grid container>
                    {!isChef && !booking.isCustom && booking.status !== BOOKING_STATUS.PENDING && booking.status !== BOOKING_STATUS.INCOMPLETE && booking.status !== BOOKING_STATUS.EXPIRED
                    && booking.status !== BOOKING_STATUS.CANCELED && booking.status !== BOOKING_STATUS.CANCELED_BY_CHEF && booking.status !== BOOKING_STATUS.CANCELED_BY_DINER
                    && <><Grid item sm={8} xs={12}>
                      <p style={style.dishesLabel}>
                        Service Charges
                      </p>
                    </Grid>
                      <Grid item sm={4} xs={12}>
                        <p style={style.priceValue}>${isChef ? parseAmountDecimal(booking.transactionFee) :
                          parseAmountDecimal(booking.serviceCharges ? booking.serviceCharges :
                            parseFloat((booking.amount * 0.05).toFixed(2)))}</p>
                      </Grid>
                    </>}
                    {!isChef && booking.isCustom && booking.status !== BOOKING_STATUS.PENDING && booking.status !== BOOKING_STATUS.INCOMPLETE
                    && booking.status !== BOOKING_STATUS.REJECTED && booking.status !== BOOKING_STATUS.CANCELED && booking.status !== BOOKING_STATUS.EXPIRED
                    && booking.status !== BOOKING_STATUS.CANCELED && booking.status !== BOOKING_STATUS.CANCELED_BY_CHEF && booking.status !== BOOKING_STATUS.CANCELED_BY_DINER
                    && <>
                      <Grid item sm={booking.isCustom ? 7 : 8} xs={12}>
                      <p style={style.dishesLabel}>
                        Service Charges
                      </p>
                    </Grid>
                      <Grid item sm={booking.isCustom ? 5 : 4} xs={12}>
                        <p style={style.priceValue}>${isChef ? parseAmountDecimal(booking.transactionFee) : parseAmountDecimal(booking.serviceCharges ? booking.serviceCharges : parseFloat((booking.amount * 0.05).toFixed(2)))}</p>
                      </Grid>
                    </>}
                    {booking.isRefund && (
                      <>
                        <Grid item sm={booking.isCustom ? 7 : 8} xs={12}>
                          <p style={style.dishesLabel}>
                            Refunded Amount
                          </p>
                        </Grid>
                        <Grid item sm={booking.isCustom ? 5 : 4} xs={12}>
                          <p style={style.priceValue}>${isChef ? parseAmountDecimal(booking.refundAmount) : parseAmountDecimal(booking.refundAmount + (booking.serviceCharges ? booking.serviceCharges : parseFloat((booking.amount * 0.05).toFixed(2))))}</p>
                        </Grid>
                        {booking.chefChargedForCancellation && isChef && <><Grid item sm={booking.isCustom ? 7 : 8} xs={12}>
                          <p style={style.dishesLabel}>
                            Penalty Charges
                          </p>
                        </Grid>
                          <Grid item sm={booking.isCustom ? 5 : 4} xs={12}>
                          <p style={style.priceValue}>${parseAmountDecimal(25)}</p>
                          </Grid></>}
                      </>
                    )}
                    {((booking.isRefund && booking.chefTransferAmount > 0) || !booking.isRefund) &&
                    isChef && booking.transactionFee
                      ? (
                      <>
                        <Grid item sm={booking.isCustom ? 7 : 8} xs={12}>
                          <p style={style.dishesLabel}>
                            Transaction Fee
                            <button onClick={() => this.fetchTransactionFee(booking.id, booking)} style={{
                              background: 'none',
                              border: 'none',
                              cursor: 'pointer'
                            }}>
                              <InfoOutlined fontSize="small" />
                            </button>
                          </p>
                        </Grid>
                        <Grid item sm={booking.isCustom ? 5 : 4} xs={12}>
                          <p style={style.priceValue}>${parseAmountDecimal(booking.transactionFee)}</p>
                        </Grid>
                      </>
                    ) : (<></>)}
                  </Grid>
                  <Grid container>
                    {(booking.isRefund && booking.chefTransferAmount > 0 && booking.status !== BOOKING_STATUS.INCOMPLETE) ||
                    (!booking.isRefund && !booking.isCustom && booking.status !== BOOKING_STATUS.INCOMPLETE) ? (
                      <>
                        <Grid item sm={booking.isCustom ? 7 : 8} xs={12}>
                          <p style={style.dishesLabel}>
                            {isChef ? 'Net Earnings' : booking.isRefund ? 'Cancelation Charges' : 'Net Amount'}
                          </p>
                        </Grid>
                        <Grid item sm={booking.isCustom ? 5 : 4} xs={12}>
                          <p style={style.priceValue}>${booking.isRefund ? isChef ?  parseAmountDecimal(booking.chefTransferAmount - booking.transactionFee) : parseAmountDecimal(booking.amount - booking.refundAmount) : isChef ? parseAmountDecimal(booking.amount - booking.transactionFee) : parseAmountDecimal(booking.amount + (booking.serviceCharges ? booking.serviceCharges : parseFloat((booking.amount * 0.05).toFixed(2))))}</p>
                        </Grid>
                      </>
                    ) : (<></>)}
                  </Grid>
                  {booking.isCustom  && booking.status !== BOOKING_STATUS.INCOMPLETE && (booking.status === BOOKING_STATUS.ACCEPTED || booking.status === BOOKING_STATUS.COMPLETED || booking.status === BOOKING_STATUS.COMPLETED_BY_CHEF || booking.status === BOOKING_STATUS.COMPLETED_BY_USER) &&
                  <Grid container>
                    {(booking.isRefund && booking.chefTransferAmount > 0) ||
                    (!booking.isRefund) ? (
                      <>
                        <Grid item sm={booking.isCustom ? 7 : 8} xs={12}>
                          <p style={style.dishesLabel}>
                            {isChef ? 'Net Earnings' : booking.isRefund ? 'Cancelation Charges' : 'Net Amount'}
                          </p>
                        </Grid>
                        <Grid item sm={booking.isCustom ? 5 : 4} xs={12}>
                          <p style={style.priceValue}>${booking.isRefund ? isChef ?  parseAmountDecimal(booking.chefTransferAmount - booking.transactionFee) : parseAmountDecimal(booking.amount - booking.refundAmount) : isChef ? parseAmountDecimal(booking.amount - booking.transactionFee) : parseAmountDecimal(booking.amount + (booking.serviceCharges ? booking.serviceCharges : parseFloat((booking.amount * 0.05).toFixed(2))))}</p>
                        </Grid>
                      </>
                    ) : (<></>)}
                  </Grid>}
                </Grid>

                <Hidden mdUp>
                  <Grid item sm={12} md={5} style={{ textAlign: "right", marginTop: 30 }}>
                    {booking.status === BOOKING_STATUS.INCOMPLETE && (
                      <Button
                        data-test-id={"continuecard"}

                        variant={"contained"}
                        size={"small"}
                        style={style.confirmedButton}
                        onClick={this.props.onContinue}
                      >
                        Continue
                      </Button>
                    )}
                    {booking.status === BOOKING_STATUS.ACCEPTED && !showComplete && (
                      <Button
                        data-test-id={"confirmedcard"}

                        variant={"contained"}
                        size={"small"}
                        style={style.confirmedButton}
                        onClick={this.props.onViewDetails}
                      >
                        Confirmed
                      </Button>
                    )}
                    {booking.status === BOOKING_STATUS.ACCEPTED && showComplete && (
                      <Button
                        data-test-id={"completecard"}

                        variant={"contained"}
                        size={"small"}
                        style={style.confirmedButton}
                        onClick={this.props.onComplete}
                      >
                        Confirmed
                      </Button>
                    )}

                    {booking.status === BOOKING_STATUS.ACCEPTED && (
                      <p style={style.confirmMessage}>
                        This engagement is confirmed.
                      </p>
                    )}

                    {booking.status === BOOKING_STATUS.PENDING && (
                      <Button
                        data-test-id={"pendingcard"}

                        variant={"contained"}
                        size={"small"}
                        style={style.pendingButton}
                      >
                        Pending
                      </Button>
                    )}
                    {booking.status === BOOKING_STATUS.PENDING && !isChef && (
                      <p style={style.confirmMessage}>
                        Awaiting chef's response.
                      </p>
                    )}
                    {booking.status === BOOKING_STATUS.PENDING && isChef && (
                      <p style={style.confirmMessage}>
                        Please review your engagement.
                      </p>
                    )}
                    {(booking.status === BOOKING_STATUS.COMPLETED || booking.status === BOOKING_STATUS.COMPLETED_BY_USER || booking.status === BOOKING_STATUS.COMPLETED_BY_CHEF) && (
                      <Button
                        data-test-id={"completedcard"}
                        variant={"outlined"}
                        size={"small"}
                        style={style.confirmedButton}
                      >
                        Completed
                      </Button>
                    )}
                    {(booking.status === BOOKING_STATUS.CANCELED || booking.status === BOOKING_STATUS.REJECTED || booking.status === BOOKING_STATUS.EXPIRED
                      || booking.status === BOOKING_STATUS.CANCELED_BY_CHEF || booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_DINER || booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_CHEF) && (
                      <Button
                        data-test-id={"canceledcard"}

                        variant={"contained"}
                        size={"small"}
                        style={style.cancelButton}
                        onClick={this.props.onCanceled}
                      >
                        {booking.status === BOOKING_STATUS.CANCELED || booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_DINER || booking.status === BOOKING_STATUS.CANCELED_BY_DINER
                        || booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_CHEF ? 'Canceled' : booking.status === BOOKING_STATUS.EXPIRED ? 'Expired' : 'Declined'}
                      </Button>
                    )}
                    {booking.status === BOOKING_STATUS.CANCELED || booking.status === BOOKING_STATUS.CANCELED_BY_DINER && (
                      <p style={style.confirmMessage}>
                        This engagement has been {booking.status === BOOKING_STATUS.REJECTED ? 'declined by chef.' : booking.status === BOOKING_STATUS.CANCELED_BY_CHEF ? 'canceled by chef.' : 'canceled.'}
                      </p>
                    )}
                    {(booking.status === BOOKING_STATUS.COMPLETED_BY_USER || booking.status === BOOKING_STATUS.COMPLETED_BY_CHEF || booking.status === BOOKING_STATUS.COMPLETED) && (
                      <p style={style.confirmMessage}>
                        This engagement has been completed.
                      </p>
                    )}
                  </Grid>
                </Hidden>

                {!this.props.hideButtons && <Grid item md={4} sm={12} style={{ textAlign: "right", display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    {(booking.status !== BOOKING_STATUS.INCOMPLETE && booking.status !== BOOKING_STATUS.PENDING) && (
                     <Button
                     data-test-id={"chefviewdtls"}

                            variant={"outlined"}
                            size={"small"}
                            style={style.viewDetailsButton}
                            onClick={isChef ? this.props.onViewAccepted : this.props.onViewDetails}
                        >
                            View details
                        </Button>
                    )}
                  {booking.status === BOOKING_STATUS.PENDING && !booking.proposalMade && booking.isCustom && isChef && (
                    <Button
                      data-test-id={"chefmakeproposal"}
                      variant={"outlined"}
                      size={"small"}
                      style={{ ...style.viewDetailsButton, marginBottom: 10 }}
                      onClick={() => {
                        this.setState({
                          showProposalModal: true,
                          selectedMonth: moment(booking.date).format('MM'),
                          selectedChefId: booking.chefId
                        }, () => { this.fetchMonthlySlots() });
                        this.getUserProfile(this.props.isChef ? booking.userId : booking.chefId);
                      }}
                    >
                      Make Proposal
                    </Button>
                  )}

                  {booking.status === BOOKING_STATUS.PENDING && booking.proposalMade && (
                    <Button
                      data-test-id={"viewproposalmade"}
                      variant={"outlined"}
                      size={"small"}
                      style={{ ...style.viewDetailsButton, marginBottom: 10 }}
                      onClick={() => {
                        this.setState({ showProposalAcceptedModal: true });
                        client.mutate({
                          mutation: UPDATE_PROPOSAL_READ,
                          variables: {
                            id: booking.id
                          }
                        })
                          .then(() => {
                            // if (this.props.fetchAgain) { this.props.fetchAgain() }
                          })
                          .catch(err => console.error('ERR Updating proposal as Read'))
                      }}
                    >
                      View Proposal
                      {!booking.isProposalRead && booking.proposedBy !== this.props.userId && <div style={{  width: 15, height: 15, borderRadius: 30, backgroundColor: 'green', border: '1px solid #fff', position: 'absolute', right: 0, top: -10 }} />}
                    </Button>
                  )}

                  {(booking.status == BOOKING_STATUS.REJECTED || booking.status === BOOKING_STATUS.CANCELED
                    || booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_DINER || booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_CHEF) && !isChef &&  (
                    <p style={{color: 'red'}}>{booking.message}</p>
                  )}
                    {booking.status == BOOKING_STATUS.PENDING &&  (
                        <Button
                        data-test-id={"viewdtlspend"}

                            variant={"contained"}
                            size={"small"}
                            style={style.viewDetailsButton}
                            onClick={this.props.onViewDetails}
                        >
                            View details
                        </Button>
                    )}
                  {(booking.status == BOOKING_STATUS.COMPLETED || booking.status == "COMPLETED_BY_USER" || booking.status == "COMPLETED_BY_CHEF") && isChef && (

                      <>
                        <br />
                        <Button
                        data-test-id={"reviewbtn"}
                            variant={"contained"}
                            size={"small"}
                            style={{...style.viewDetailsButton, marginTop:10}}
                            onClick={ this.props.onReview}
                        >
                            Write a review
                        </Button>
                      </>

                  )}

                    {(booking.status == BOOKING_STATUS.COMPLETED || booking.status == "COMPLETED_BY_USER" || booking.status == "COMPLETED_BY_CHEF") && !isChef && (
                        <p>
                        <Button
                           data-test-id={"reviewbtn"}
                            variant={"contained"}
                            size={"small"}
                            style={style.viewDetailsButton}
                            onClick={this.props.onReview}
                        >
                            Write a review
                        </Button>
                        </p>
                    )}

                </Grid>}
              </Grid>
            </Grid>
          </Grid>
          {this.state.showTransactionModal && <Modal
            open={this.state.showTransactionModal}
            onClose={() => this.setState({ showTransactionModal: false })}
          >
            <div className="modal-wrapper-booking-transaction">
              <div className="modal-close">
                <h3 className="modal-close-header">Transaction Charges</h3>
                <button onClick={() => this.setState({ showTransactionModal: false })}>
                  <CloseOutlined />
                </button>
              </div>
              <span dangerouslySetInnerHTML={{ __html: this.state.transactionFeeMsg }} />
            </div>
          </Modal>}

          <Drawer
            open={this.state.showProposalModal}
            anchor={'right'}
          >
            <div style={{ width: 480, padding: '10px 15px 50px', boxSizing: 'border-box' }}>
            <div className="modal-wrapper-booking-transaction-proposal-drawer">
              <div className="modal-close">
                <h3 className="modal-close-header">Make a Proposal</h3>
                <button style={{ border: 'none', background: 'transparent' }} onClick={() => this.setState({ showProposalModal: false, userProfileDetails: null })}>
                  <CloseOutlined />
                </button>
              </div>

              <Grid container>
                <Grid item xs={12} md={12}>
                  <Grid container className="make-proposal-wrapper">

                    <Grid item xs={12}>
                      <div className="diner-details-time-wrapper booking-slider-inner-wrapper" style={{ marginRight: 0, width: '100%', flexDirection: 'column' }}>
                        <div className="diner-details-date-wrapper" style={{ marginRight: 0, width: '100%' }}>
                          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10, justifyContent: 'space-between' }}>

                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              {this.state.userProfileDetails ?  this.state.userProfileDetails.profilePic ?
                                <Avatar src={this.state.userProfileDetails ?
                                  this.state.userProfileDetails.profilePic ?
                                    this.state.userProfileDetails.profilePic :
                                    '/images/simple-chef.png' : '/images/simple-chef.png'}
                                        style={{ width: 60, height: 60, border: '1px solid #ff8000', marginRight: 5 }}
                                /> : <AccountCircle style={{ color: '#ff8000', fontSize: 60, marginRight: 5 }} /> :
                                <AccountCircle style={{ color: '#ff8000', fontSize: 60, marginRight: 5 }} />}
                              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'column' }}>
                                <div style={{ fontSize: 18, fontWeight: 500 }}>{isChef ? booking.userName : booking.chefName}</div>
                                {isChef && booking.address && <div style={{ fontSize: 12, fontWeight: 400 }}>
                                  {booking.address.city}, {booking.address.state} {booking.address.zipcode}
                                </div>}
                              </div>
                            </div>

                            <div style={{display: 'flex', alignItems: 'flex-end', justifyContent: 'center', flexDirection: 'column'}}>
                              <div style={{ fontSize: 16, fontWeight: 500 }}>${booking.startPrice} - ${booking.endPrice}</div>
                              <div style={{ fontSize: 16 }}>
                                <span style={{ fontWeight: 500 }}>Diner(s): </span>{booking.dinerSize}
                              </div>
                            </div>
                          </div>
                        </div>

                        <Divider variant="inset" style={{margin: 'auto', width: "100%"}}/>

                        <div className="diner-details-date-wrapper" style={{ marginRight: 0, width: '100%', marginTop: 30 }}>
                          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10, justifyContent: 'space-between' }}>
                            <div className="inner-label" style={{ fontWeight: 500, textAlign: 'left', fontSize: 18, fontFamily: webFont }}>Propose Date</div>
                            <div>
                              <MuiPickersUtilsProvider utils={FrDateFnsUtils}>
                                <DatePicker
                                  style={{ color: primaryColor, display: "none",}}
                                  value={this.state.selectedDate}
                                  animateYearScrolling
                                  // autoOk={true}
                                  onChange={this.handleDateChange.bind(this)}
                                  onMonthChange={this.handleMonthChange}
                                  onAccept={(d) => {
                                    this.openDatePicker();
                                  }}
                                  onClose={() => {
                                    this.openDatePicker();
                                  }}
                                  minDate={moment.isMoment(minDate) ? minDate.toDate() : moment(minDate, 'YYYY-MM-DD').toDate()}
                                  open={this.state.showDatePicker}
                                  renderDay={this.renderWrappedWeekDay}
                                />

                                <Typography
                                  align={"right"}
                                  style={{
                                    fontSize: 18,
                                    color: primaryColor,
                                    marginLeft: -5
                                  }}
                                  onClick={this.openDatePicker}
                                >
                                  {moment(this.state.selectedDate).format("DD MMM YYYY")}
                                </Typography>

                              </MuiPickersUtilsProvider>
                            </div>
                          </div>
                        </div>

                        <div className="diner-details-date-wrapper" style={{ marginRight: 0, width: '100%', marginTop: 30 }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div className="inner-label" style={{ fontWeight: 500, textAlign: 'left', fontSize: 18, fontFamily: webFont }}>Propose Time</div>
                            <div>
                              <div style={{ marginLeft: -130, fontSize: 14, fontWeight: 500 }}>FROM</div>
                              <Select
                                inputProps={{MenuProps: {disableScrollLock: true}}}
                                className="select-option"
                                data-test-id={"fromhour-id"}
                                value={this.state.selectedTimeHour || moment(booking.timeSlot.start, "hh:mm a").format("h")}
                                style={{ fontSize: "18px",
                                  fontWeight:400,
                                  fontFamily: webFont, marginLeft: 20 }}
                                onChange={
                                  evt => this.setState({ selectedTimeHour: evt.target.value })
                                }
                              >
                                {[1,2,3,4,5,6,7,8,9,10,11,12].map(monthDay => (
                                  <MenuItem key={monthDay} value={monthDay} style={{ fontSize: "18px",
                                    fontWeight:400,
                                    fontFamily: webFont }}>
                                    {monthDay < 10 ? `0${monthDay}` : monthDay}
                                  </MenuItem>
                                ))}

                              </Select>

                              <Select
                                inputProps={{MenuProps: {disableScrollLock: true}}}
                                className="select-option"
                                data-test-id={"fromminute-id"}
                                value={this.state.selectedTimeMinutes ? this.state.selectedTimeMinutes
                                  : booking.proposedTime ?
                                  moment(booking.proposedTime, "HH:mm").format("mm") :
                                  moment(booking.timeSlot.start, "HH:mm").format("mm")}
                                style={{ fontSize: "18px",
                                  fontWeight:400,
                                  fontFamily: webFont, marginLeft: 20 }}
                                onChange={
                                  evt => this.setState({ selectedTimeMinutes: evt.target.value })
                                }
                              >
                                {['00', '15', '30', '45'].map(monthDay => (
                                  <MenuItem key={monthDay} value={monthDay} style={{ fontSize: "18px",
                                    fontWeight:400,
                                    fontFamily: webFont }}>
                                    {monthDay}
                                  </MenuItem>
                                ))}
                              </Select>
                              <Select
                                inputProps={{MenuProps: {disableScrollLock: true}}}
                                className="select-option"
                                data-test-id={"frommeridiem-id"}
                                value={this.state.selectedMeridiem ?  this.state.selectedMeridiem.trim() : booking.proposedTimeEnd ?
                                  parseInt(moment(booking.proposedTimeEnd, "HH:mm").format("mm")) :
                                  moment(booking.timeSlot.start, "hh:mm a").format("A")}
                                onChange={
                                  evt => this.setState({ selectedMeridiem: evt.target.value })
                                }
                                style={{ fontSize: "18px",
                                  fontWeight:400,
                                  fontFamily: webFont, marginLeft: 20 }}
                              >
                                <MenuItem value="AM">AM</MenuItem>
                                <MenuItem value="PM">PM</MenuItem>
                              </Select>
                            </div>
                          </div>
                        </div>

                        <div className="diner-details-date-wrapper" style={{ marginRight: 0, width: '100%', marginTop: 30 }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div className="inner-label" style={{ fontWeight: 500, textAlign: 'left', fontSize: 18, fontFamily: webFont }}>{' '}</div>
                            <div>
                              <div style={{ marginLeft: -145, fontSize: 14, fontWeight: 500 }}>TO</div>
                              <Select
                                inputProps={{MenuProps: {disableScrollLock: true}}}
                                className="select-option"
                                data-test-id={"fromhour-id"}
                                value={this.state.selectedTimeHourEnd || moment(booking.timeSlot.end, "hh:mm a").format("h")}
                                style={{ fontSize: "18px",
                                  fontWeight:400,
                                  fontFamily: webFont, marginLeft: 20 }}
                                onChange={
                                  evt => this.setState({ selectedTimeHourEnd: evt.target.value })
                                }
                              >
                                {[1,2,3,4,5,6,7,8,9,10,11,12].map(monthDay => (
                                  <MenuItem key={monthDay} value={monthDay} style={{ fontSize: "18px",
                                    fontWeight:400,
                                    fontFamily: webFont }}>
                                    {monthDay < 10 ? `0${monthDay}` : monthDay}
                                  </MenuItem>
                                ))}

                              </Select>
                              <Select
                                inputProps={{MenuProps: {disableScrollLock: true}}}
                                className="select-option"
                                data-test-id={"fromminute-id"}
                                value={this.state.selectedTimeMinutesEnd || moment(booking.timeSlot.end, "hh:mm a").format("mm")}
                                style={{ fontSize: "18px",
                                  fontWeight:400,
                                  fontFamily: webFont, marginLeft: 20 }}
                                onChange={
                                  evt => this.setState({ selectedTimeMinutesEnd: evt.target.value })
                                }
                              >
                                {['00', '15', '30', '45'].map(monthDay => (
                                  <MenuItem key={monthDay} value={monthDay} style={{ fontSize: "18px",
                                    fontWeight:400,
                                    fontFamily: webFont }}>
                                    {monthDay}
                                  </MenuItem>
                                ))}
                              </Select>

                              <Select
                                inputProps={{MenuProps: {disableScrollLock: true}}}
                                className="select-option"
                                data-test-id={"frommeridiem-id"}
                                value={this.state.selectedMeridiemEnd || moment(booking.timeSlot.end, "hh:mm a").format("A")}
                                onChange={
                                  evt => this.setState({ selectedMeridiemEnd: evt.target.value })
                                }
                                style={{ fontSize: "18px",
                                  fontWeight:400,
                                  fontFamily: webFont, marginLeft: 20 }}
                              >
                                <MenuItem value="AM">AM</MenuItem>
                                <MenuItem value="PM">PM</MenuItem>
                              </Select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Grid>

                    <Grid item xs={12} style={{ display: 'flex', marginTop: 30, width: '100%', marginBottom: 20 }}>
                      <div className="diner-details-date-wrapper" style={{ marginRight: 0, width: '100%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <div className="inner-label" style={{ fontWeight: 500, width: 160, textAlign: 'left', fontSize: 18, fontFamily: webFont }}>Propose Amount</div>
                          <Input
                            name={"amount"}
                            placeholder={"Amount"}
                            label={"Amount"}
                            type={"number"}
                            value={this.state.amount}
                            onChange={(e) => {
                              const val = e.target.value;

                              if (val.length && /^\d+$/.test(val)) {
                                const convertedSize = parseInt(val);
                                if (convertedSize < 1) {
                                  NotificationManager.error('Amount cannot be less than 1', 'Booking');
                                  this.setState({amount: val});
                                } /*else if (booking.endPrice) {
                                  if (convertedSize < booking.endPrice) {
                                    NotificationManager.error('Amount cannot be more than maximum price', 'Booking');
                                    this.setState({amount: val});
                                  }
                                }*/ else this.setState({amount: convertedSize});
                              } else {
                                NotificationManager.error('Enter valid number', 'Booking');
                                this.setState({ amount: val });
                              }
                            }}
                            style={{...style.inputText, marginLeft: 20, width: 65, textAlign: 'center'}}
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                          />
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Divider variant="inset" style={{margin: 'auto', width: "100%"}}/>
                <div style={{ padding: '20px 0px', fontWeight: 500 }}>
                  {typeof chefAvailability === "object" && chefAvailability ? `Chef Availability: ${availability.join(" , ")}` : (
                    <FormHelperText id="component-error-text" style={style.error}>
                      {chefAvailability}{" "}
                    </FormHelperText>
                  )}
                </div>
                <Divider variant="inset" style={{margin: 'auto', width: "100%"}}/>
                <Grid item xs={12} md={12} style={{ display: 'flex', flexDirection: 'column' }}>
                  <p style={{ fontWeight: 500, fontSize: 18, textAlign: 'left' }}>Message</p>
                  <TextField
                    inputProps={{ 'data-test-id': 'pfabtme' }}
                    multiline
                    variant="outlined"
                    rows="5"
                    fullWidth
                    value={this.state.proposalMessage}
                    onChange={evt => {
                      this.setState({ proposalMessage: evt.target.value });
                    }}
                    style={{ ...style.setFont }}
                  />
                </Grid>
              </Grid>

              <Grid container style={{marginTop: 30, marginBottom: 10, alignItems: 'center'}} justify="center" direction="column">
                <Grid item>
                  <Button
                    data-test-id={"bkgonenext"}
                    style={{...style.setFont, ...style.sendButtonStyles}}
                    onClick={this.handleSendProposal}
                  >
                    Send
                  </Button>
                </Grid>
              </Grid>
            </div>
            </div>
          </Drawer>

          <Modal
            open={this.state.showProposalAcceptedModal}
            onClick={() => {}}
          >
            <div className="modal-wrapper-booking-transaction-proposal">
              <div className="modal-close">
                <h3 className={booking.counterProposals && booking.counterProposals.length > 0 ? "modal-close-header-proposal": "modal-close-header"}>Proposal details</h3>
                <button onClick={() => this.setState({ showProposalAcceptedModal: false })}>
                  <CloseOutlined />
                </button>
              </div>

              <Grid container>
                <Grid item xs={12} md={12}>
                  <Grid container className="make-proposal-wrapper">

                    <Grid item xs={12}>
                      <div className="diner-details-time-wrapper booking-slider-inner-wrapper" style={{ marginRight: 0, width: '100%', flexDirection: 'column' }}>
                        <div className="diner-details-date-wrapper" style={{ marginRight: 0, width: '100%' }}>
                          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 15, justifyContent: 'space-between' }}>

                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              {this.state.userProfileDetails ?  this.state.userProfileDetails.profilePic ?
                                  <Avatar src={this.state.userProfileDetails ?
                                    this.state.userProfileDetails.profilePic ?
                                      this.state.userProfileDetails.profilePic :
                                      '/images/simple-chef.png' : '/images/simple-chef.png'}
                                          style={{ width: 60, height: 60, border: '1px solid #ff8000', marginRight: 5 }}
                                  /> : <AccountCircle style={{ color: '#ff8000', fontSize: 60, marginRight: 5 }} /> :
                                <AccountCircle style={{ color: '#ff8000', fontSize: 60, marginRight: 5 }} />}
                              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'column' }}>
                                <div style={{ fontSize: 18, fontWeight: 500 }}>{isChef ? booking.userName : booking.chefName}</div>
                                {isChef && booking.address && <div style={{ fontSize: 12, fontWeight: 400 }}>
                                  {booking.address.city}, {booking.address.state} {booking.address.zipcode}
                                </div>}
                              </div>
                            </div>

                            <div style={{display: 'flex', alignItems: 'flex-end', justifyContent: 'center', flexDirection: 'column'}}>
                              <div style={{ fontSize: 16, fontWeight: 500 }}>${booking.startPrice} - ${booking.endPrice}</div>
                              <div style={{ fontSize: 16 }}>
                                <span style={{ fontWeight: 500 }}>Diner(s): </span>{booking.dinerSize}
                              </div>
                            </div>
                          </div>
                        </div>

                        <Divider variant="inset" style={{margin: 'auto', width: "100%"}}/>

                        <div className="diner-details-date-wrapper" style={{ marginRight: 0, width: '100%', marginTop: 15 }}>
                          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 15, justifyContent: 'space-between' }}>
                            <div className="inner-label" style={{ fontWeight: 500, textAlign: 'left', fontSize: 18, fontFamily: webFont }}>Proposed Date</div>
                            <div>
                              {booking.proposedDate}
                            </div>
                          </div>
                        </div>

                        <div className="diner-details-date-wrapper" style={{ marginRight: 0, width: '100%', marginTop: 10 }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div className="inner-label" style={{ fontWeight: 500, textAlign: 'left', fontSize: 18, fontFamily: webFont }}>Proposed Time</div>
                            <div>
                              {moment(booking.proposedTime, 'HH:mm').format('h:mm a')} -
                              {moment(booking.proposedTimeEnd, 'HH:mm').format('h:mm a')}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Grid>

                    <Grid item xs={12} style={{ display: 'flex', marginTop: 20, width: '100%', marginBottom: 15 }}>
                      <div className="diner-details-date-wrapper" style={{ marginRight: 0, width: '100%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <div className="inner-label" style={{ fontWeight: 500, width: 180, textAlign: 'left', fontSize: 18, fontFamily: webFont }}>Proposed Amount</div>
                          <div>
                            $ {booking.proposedAmount}
                          </div>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Divider variant="inset" style={{margin: 'auto', width: "100%"}}/>
                {booking.proposalComments && <Grid item xs={12} md={12} style={{ display: 'flex', flexDirection: 'column' }}>
                  <p style={{ fontWeight: 500, fontSize: 18, textAlign: 'left' }}>Message</p>
                  <TextField
                    inputProps={{ 'data-test-id': 'pfabtme' }}
                    multiline
                    disabled
                    variant="outlined"
                    rows="5"
                    fullWidth
                    value={booking.proposalComments}
                    onChange={evt => {
                      this.setState({ proposalMessage: evt.target.value });
                    }}
                    style={{ ...style.setFont }}
                  />
                </Grid>}
              </Grid>

              <Grid container style={{marginTop: 15, marginBottom: 10, alignItems: 'center'}} justify="center" direction="column">
                {booking.proposedBy !== this.props.userId && <>
                <Grid item>
                  <Button
                    data-test-id={'bkgonenextaccept'}
                    style={{ ...style.setFont, ...style.proposalButton }}
                    onClick={() => {
                      client.mutate({
                          mutation: UPDATE_BOOKING,
                          variables: {
                            bookingId: booking.id,
                            status: BOOKING_STATUS.ACCEPTED
                          }
                        })
                        .then(() => {
                          this.setState({ showProposalAcceptedModal: false });
                          NotificationManager.info('Proposal and booking successfully accepted', 'Proposal', 4000);
                          if (this.props.fetchAgain) { this.props.fetchAgain() }
                        })
                        .catch(err => {
                          console.error('ERROR accepting proposal: ', err);
                        });
                    }}
                  >
                    Accept
                  </Button>
                  <Button
                    data-test-id={'bkgonenextcounterproposal'}
                    style={{ ...style.setFont, ...style.proposalButton }}
                    onClick={() => {
                      this.setState({ showProposalAcceptedModal: false });
                      setTimeout(() => {
                        this.setState({
                          showProposalModal: true, isCounterProposal: true, amount: booking.proposedAmount,
                          selectedDate: moment(booking.proposedDate).toDate(), selectedMonth: moment(booking.proposedDate).format('MM'),
                          selectedYear: booking.proposedDate.split(' ').length > 2 ? booking.proposedDate.split(' ')[2] : new Date().getFullYear(),
                          selectedTimeHour: parseInt(moment(booking.proposedTime, 'HH:mm').format('h')),
                          selectedTimeMinutes: moment(booking.proposedTime, 'HH:mm').format('mm'),
                          selectedMeridiem: moment(booking.proposedTime, 'HH:mm').format('A'),
                          selectedTimeHourEnd: parseInt(moment(booking.proposedTimeEnd, 'HH:mm').format('h')),
                          selectedTimeMinutesEnd: moment(booking.proposedTimeEnd, 'HH:mm').format('mm'),
                          selectedMeridiemEnd: moment(booking.proposedTimeEnd, 'HH:mm').format('A'),
                          selectedChefId: booking.chefId,
                        }, () => { this.fetchMonthlySlots() });
                      }, 800)
                    }}
                  >
                    Counter
                  </Button>
                </Grid>
                <Grid item style={{ marginTop: 15, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                  <div style={{ minWidth: booking.counterProposals && booking.counterProposals.length > 0 ? 166 : 176 }}>
                    {booking.counterProposals && booking.counterProposals.length > 0 && <Button
                      data-test-id={'bkgonenextcounterproposal'}
                      style={{ ...style.setFont, ...style.proposalButton }}
                      onClick={() => {
                        this.setState({ showProposalAcceptedModal: false });
                        setTimeout(() => {
                          this.setState({ showProposalHistory: true });
                        }, 800);
                      }}
                    >
                      History
                    </Button>}
                  </div>
                  <Button
                    data-test-id={'bkgonenextdecline'}
                    style={{ ...style.setFont, ...style.proposalButton }}
                    onClick={() => {
                      client.mutate({
                          mutation: UPDATE_BOOKING,
                          variables: {
                            bookingId: booking.id,
                            status: BOOKING_STATUS.REJECTED,
                            rejectReason: 'Proposal not accepted by the diner.'
                          }
                        })
                        .then(() => {
                          this.setState({ showProposalAcceptedModal: false });
                          NotificationManager.info('Proposal and booking declined', 'Proposal', 4000);
                          if (this.props.fetchAgain) { this.props.fetchAgain() }
                        })
                        .catch(err => {
                          console.error('ERROR cancelling proposal: ', err)
                        });
                    }}
                  >
                    Decline
                  </Button>
                </Grid>
                </>}
              </Grid>
            </div>
          </Modal>

          <Modal
            open={this.state.showProposalHistory}
            onClose={() => {
              this.setState({ showProposalHistory: false });
              setTimeout(() => {
                this.setState({ showProposalAcceptedModal: true });
              }, 800);
            }}
          >
            <div className="modal-wrapper-booking-transaction">
              <div className="modal-close">
                <h3 className={"modal-close-header"}>Proposal history</h3>
                <button onClick={() => this.setState({ showProposalHistory: false })}>
                  <CloseOutlined />
                </button>
              </div>

              <Grid container style={{ maxHeight: 500, minHeight: 200, height: 'auto', overflowY: 'scroll' }}>
                {booking.counterProposals && booking.counterProposals.reverse().map(proposal => (
                  <Grid item xs={12} flexDirection="column" className={"proposal-history-wrapper"} style={{ marginBottom: 20,  alignItems: 'flex-start', justifyContent: 'center' }}>
                    <div className="proposal-history-item">
                      <div className="proposal-history-item-details">
                        <strong>Proposed By </strong>
                        <span>{proposal.proposedBy === this.props.userId ? 'Me': !isChef ? booking.chefName : booking.userName}</span>
                      </div>
                      <div className="proposal-history-item-details">
                        <strong>Date: </strong> <span>{proposal.proposedDate}</span>
                      </div>

                      <div className="proposal-history-item-details">
                        <strong>Time: </strong> <span>{moment(proposal.proposedTime, 'HH:mm').format('h:mm A')}</span>
                      </div>

                      <div className="proposal-history-item-details">
                        <strong>Amount: </strong> <span>$ {proposal.proposedAmount}</span>
                      </div>

                      {proposal.proposalComments && <div className="proposal-history-item-details-column" style={{ alignItems: 'flex-start' }}>
                        <div><strong>Message: </strong></div>
                        <div className="proposal-message">
                          <span>{proposal.proposalComments}</span>
                        </div>
                      </div>}
                    </div>
                  </Grid>
                ))}
              </Grid>

            </div>
          </Modal>
        </CardContent>
      </Card>
    );
  }
}


const style = {
  container: {
    display: "flex",
    justifyContent: "space-between"
  },
  label: {
    margin: 0,
    fontSize: 15,
    fontFamily: webFont,
    fontWeight: 400,
  },
  labelBold: {
    margin: 0,
    fontSize: 15,
    fontFamily: webFont,
    fontWeight: 400,
  },
  value: {
    margin: 0,
    fontSize: 15,
    fontFamily: webFont,
    paddingRight: 15,
  },
  userName: {
    fontFamily: webFont,
    fontSize: "20px",
    fontWeight: 500,
    margin: 0
  },
  dishesLabel: {
    fontFamily: webFont,
    fontSize: "15px",
    fontWeight: 400,
    margin: 0
  },
  priceValue: {
    margin: 0,
    fontSize: 15,
    fontFamily: webFont
  },
  confirmMessage: {
    opacity: 0.7,
    fontFamily: webFont,
    fontSize: 13,
    color: '#000'
  },
  viewDetailsButton: {
    height: 32,
    width: 154,
    textTransform: "none",
    borderRadius: 18,
    opacity: 0.7,
    border: "1px solid #ff8000",
    fontSize: 15,
    color: "#fff",
    fontFamily: webFont,
    lineHeight: "10px",
    backgroundColor: '#ff8000'
  },
  sendButtonStyles: {
    height: 40,
    width: 160,
    textTransform: "none",
    borderRadius: 18,
    opacity: 0.7,
    border: "1px solid #ff8000",
    fontSize: 16,
    color: "#fff",
    fontFamily: webFont,
    lineHeight: "22px",
    backgroundColor: '#ff8000'
  },
  proposalButton: {
    height: 40,
    minWidth: 166,
    textTransform: "none",
    borderRadius: 18,
    opacity: 0.7,
    border: "1px solid #ff8000",
    fontSize: 16,
    color: "#fff",
    fontFamily: webFont,
    lineHeight: "22px",
    backgroundColor: '#ff8000',
    marginRight: 7
  },
  confirmedButton: {
    backgroundColor: "white",
    height: 32,
    width: 121,
    color: "rgba(76, 175, 80, 0.7)",
    textTransform: "none",
    fontFamily: webFont,
    fontSize: 15,
    fontWeight: 500,
    lineHeight: "10px",
    marginTop: 10,
    marginBottom: 10,
    boxShadow: 'none',
    borderRadius: 5,
    cursor: 'default',
    border: '1px solid rgba(76, 175, 80, 0.7)'
  },
  pendingButton: {
    backgroundColor: "white",
    height: 32,
    width: 121,
    color: "rgba(255, 128, 0, 0.7)",
    textTransform: "none",
    fontFamily: webFont,
    fontSize: 15,
    fontWeight: 500,
    lineHeight: "10px",
    marginTop: 10,
    marginBottom: 10,
    boxShadow: 'none',
    borderRadius: 5,
    border: '1px solid rgba(255, 128, 0, 0.7)',
    cursor: 'default'
  },
  cancelButton: {
    backgroundColor: "white",
    height: 32,
    width: 121,
    color: "#f34016",
    textTransform: "none",
    fontFamily: webFont,
    fontSize: 15,
    fontWeight: 500,
    lineHeight: "10px",
    marginTop: 10,
    marginBottom: 10,
    borderRadius: 5,
    border: '1px solid #f34016',
    cursor: 'default'
  },
  error: {
    fontWeight: 400
  }
};

const mapStateToProps = state => {
    return {
        isChef: state.auth.isChef,
      chefAvailability: state.bookings.chefAvailability,
    };
};

const BookingCard1 = connect(mapStateToProps)(BookingCard);

export default BookingCard1;
